import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'crm-info-modal',
  templateUrl: 'crm-info-modal.template.html',
  styleUrls: ['crm-info-modal.scss'],
})
export class CRMInfoModalComponent {
  private privateDisplayDialog: boolean;

  @Input() modalTitle: string;
  @Input() modalContent: string;
  @Input() submitButtonlabel = 'OK';
  @Output() displayDialogChange = new EventEmitter();

  get displayDialog(): boolean {
    return this.privateDisplayDialog;
  }
  @Input() set displayDialog(value: boolean) {
    this.privateDisplayDialog = value;
    this.displayDialogChange.emit(this.displayDialog);
  }

  onSubmit() {
    this.displayDialogChange.emit(false);
    this.displayDialog = false;
  }
}
